// extracted by mini-css-extract-plugin
module.exports = {"tipText":"form_tipText_1PEDb"};